import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { I18nProvider } from "@/contexts/I18nContext";
import { ToastProvider } from "@/contexts/ToastContext";
import { ToastStack } from "@/components/Toast";
import { AuthProvider } from "@/contexts/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { LoginPage } from "@/pages/LoginPage";
import { EnrolPage } from "@/pages/EnrolPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { InstitutionsPage } from "@/features/institutions/InstitutionsPage";
import { NewInstitutionPage } from "@/features/institutions/NewInstitutionPage";
import { InstitutionPage } from "@/features/institutions/InstitutionPage";
import { UsersPage } from "@/features/users/UsersPage";
import { SupportPage } from "@/features/support/SupportPage";
import { EnquiriesPage } from "@/features/enquiries/EnquiriesPage";
import { LegalPage } from "@/features/legal/LegalPage";
import { MatrixPage } from "@/features/legal/MatrixPage";
import { AcceptancesPage } from "@/features/legal/AcceptancesPage";
import { CoveragePage } from "@/features/legal/CoveragePage";
import { AiPage } from "@/features/ai/AiPage";
import { RetentionPage } from "@/features/platform/RetentionPage";
import { HealthPage } from "@/features/platform/HealthPage";
import { MigrationsPage } from "@/features/platform/MigrationsPage";

/**
 * Routes.
 *
 * Every one of them is inside `ProtectedRoute` except `/login`. `/enrol` is
 * inside it too: somebody has to be signed in and be an admin before there is
 * anything to enrol a second factor for.
 */
export function App() {
  return (
    <I18nProvider>
      <ToastProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/enrol"
                element={
                  <ProtectedRoute>
                    <EnrolPage />
                  </ProtectedRoute>
                }
              />

              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardPage />} />
                <Route path="enquiries" element={<EnquiriesPage />} />
                <Route path="institutions" element={<InstitutionsPage />} />
                <Route path="institutions/new" element={<NewInstitutionPage />} />
                <Route path="institutions/:institutionId" element={<InstitutionPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="legal" element={<LegalPage />} />
                <Route path="legal/matrix" element={<MatrixPage />} />
                <Route path="legal/acceptances" element={<AcceptancesPage />} />
                <Route path="legal/coverage" element={<CoveragePage />} />
                <Route path="ai" element={<AiPage />} />
                <Route path="retention" element={<RetentionPage />} />
                <Route path="health" element={<HealthPage />} />
                <Route path="migrations" element={<MigrationsPage />} />
                <Route path="support" element={<SupportPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <ToastStack />
      </ToastProvider>
    </I18nProvider>
  );
}
